module.exports = __webpack_public_path__ + "media/img/auth/campus-cap-login-d46f7b26875319347b46ea1218d6fd28.jpg";